import api from "@/services/api";

export default {
  fetchConversationsWithObjects() {
    return api.post(`conversations/fetch/`);
  },
  fetchConversationsByAdmin() {
    return api.post(`conversations/fetch_by_admin/`);
  },
  fetchConversations() {
    return api.get(`conversations/`);
  },
  postConversation(payload) {
    return api.post(`conversations/`, payload).then(response => response.data);
  },
  deleteConversation(pk) {
    return api.delete(`conversations/${pk}`).then(response => response.data);
  }

  // may not need this
  //   patchConversation(payload, pk) {
  //     return api.patch(`conversations/${pk}/`, payload).then(response => response.data);
  //   }
};
